// Setup › WORKSPACE › Decisions (B5-DECIDE): `/c/{slug}/setup/decisions`. Managers only, like
// the rest of Setup (wave 22: not in routes/c.$slug.setup.tsx `MEMBER_PAGES`).
import { createRoute } from "@tanstack/react-router";
import { DecisionsScreen } from "../features/decide/decisions";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupDecisionsRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "decisions",
  component: function SetupDecisionsPage() {
    const { api } = setupDecisionsRoute.useRouteContext();
    return <DecisionsScreen api={api} company={useCompany()} />;
  },
});
